export default __webpack_public_path__ + "static/starWars-c34281f223f1d8870958e09bc28fc9cc.png";